// extracted by mini-css-extract-plugin
module.exports = {"accordionList":"HistoryList_accordionList__1qtI1"};